import React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { connect } from 'react-redux';
import StoreIcon from '@material-ui/icons/Store';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import Spinner from '../Spinner';
import Button from '../Button';
import styles from './AddressInput.styles';
import { onPressAddAddress, animatePlaceHolderText } from './AddressInput.services';
import {
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_DELIVERY,
  PLACEHOLDER_TEXT
} from '../../constants';
import { PRIMARY, LINK } from '../../constants/configuration';
import { getAddressFormatted, sendCloudWatchAlert } from '../../utils';
import {
  showChooseShop,
  updateClosestShops,
  updateAddressTemp,
  showAddressModal,
  showConnexionModal
} from '../../redux/actions';

const INITIAL_STATE = {
  loading: false,
  address: '',
  errorMessage: '',
  placeId: null
};

const searchOptions = {
  componentRestrictions: { country: ['fr', 'mc', 'gf'] }
};

class AddressInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  handleError = (status, clearSuggestions) => {
    const errorMessage = String(status);
    if (!errorMessage.includes('ZERO_RESULTS')) {
      sendCloudWatchAlert(`Error from google api ${status}`);
    }
    this.setState({ errorMessage: status }, () => {
      clearSuggestions();
    });
  };

  handleChange = address => {
    this.setState({ address });
  };

  handleSelect = (address, placeId) => {
    this.setState({ address, placeId });
  };

  componentDidMount = () => {
    if (this.inputElement) {
      animatePlaceHolderText(this.inputElement, PLACEHOLDER_TEXT, 200);
    }
  };

  render() {
    const {
      orderTypes,
      customerAddress,
      addressShop,
      googleMapsEnabled,
      showConnexionModal,
      userConnected,
      isMobile,
      marketplace,
      addressModal,
      secondaryColor,
      fromModal
    } = this.props;
    const { address, loading } = this.state;
    const marketplaceEnabled = marketplace && marketplace.enabled;
    const deliveryLabel = isMobile ? 'En Livraison' : 'Commande en Livraison';
    const clickAndCollectLabel = isMobile ? 'À Emporter' : 'Commande à Emporter';
    return (
      <div className={`${!addressModal ? 'p-3' : 'px-0 px-sm-3'}`}>
        {customerAddress && (
          <div className='mb-2 row text-center justify-content-center align-items-center'>
            <div
              className='shadow-sm rounded bg-light'
              style={{ width: '100%', backgroundColor: '#F8F9F9' }}
            >
              <div className='mx-3 py-1' style={{ display: 'flex' }}>
                {customerAddress.orderType === ORDER_TYPE_DELIVERY && (
                  <>
                    <DirectionsBikeIcon
                      className='text-secondary'
                      fontSize='large'
                      style={{ alignSelf: 'center' }}
                    />
                    <div className='ml-3 text-secondary'>
                      <h5 className='text-order-type mb-0' style={{ textAlign: 'start' }}>
                        {deliveryLabel}:
                      </h5>
                      <h6 style={{ textAlign: 'start' }} className='text-secondary no-localization'>
                        {getAddressFormatted(customerAddress)}
                      </h6>
                    </div>
                  </>
                )}
                {customerAddress.orderType === ORDER_TYPE_CLICK_AND_COLLECT && (
                  <>
                    <StoreIcon
                      className='text-secondary'
                      fontSize='large'
                      style={{ alignSelf: 'center' }}
                    />
                    <div className='ml-3 text-secondary '>
                      <h5 className='text-order-type mb-0' style={{ textAlign: 'start' }}>
                        {clickAndCollectLabel}:
                      </h5>
                      <h6 style={{ textAlign: 'start' }} className='text-secondary'>
                        {marketplaceEnabled
                          ? getAddressFormatted(customerAddress)
                          : getAddressFormatted(addressShop)}
                      </h6>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        <div>
          <p className='text-secondary mb-2'>
            Entrez votre adresse pour trouver {marketplaceEnabled ? 'les commerces' : 'le commerce'}{' '}
            à proximité
          </p>
          {googleMapsEnabled && (
            <PlacesAutocomplete
              value={address}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
              onError={this.handleError}
              shouldFetchSuggestions={address.length > 6}
              highlightFirstSuggestion
              searchOptions={searchOptions}
              debounce={400}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div>
                  <div className='input-group'>
                    <input
                      {...getInputProps({
                        className: 'p-2 shadow form-control no-localization',
                        ref: el => {
                          this.inputElement = el;
                        },
                        placeholder: PLACEHOLDER_TEXT,
                        style: styles.addressInput,
                        'aria-describedby': 'button-addon3',
                        type: 'text'
                      })}
                    />
                  </div>
                  <div
                    className='autocomplete-dropdown-container'
                    style={{ position: 'absolute', zIndex: 5000 }}
                  >
                    {loading && <Spinner />}
                    {suggestions.map(suggestion => {
                      const className = suggestion.active
                        ? 'suggestion-item--active p-2'
                        : 'suggestion-item p-2';
                      const style = suggestion.active
                        ? {
                            backgroundColor: '#fafafa',
                            cursor: 'pointer',
                            color: 'black'
                          }
                        : {
                            backgroundColor: '#ffffff',
                            cursor: 'pointer',
                            color: 'black'
                          };
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className,
                            style
                          })}
                        >
                          <strong className='no-localization'>
                            {suggestion.formattedSuggestion.mainText}
                          </strong>{' '}
                          <small className='no-localization'>
                            {suggestion.formattedSuggestion.secondaryText}
                          </small>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
          )}
          {!fromModal && (
            <div className='mt-2'>
              {loading && (
                <div className='row justify-content-center'>
                  <Spinner />
                </div>
              )}
              {!loading && (
                <>
                  <div className='row justify-content-around justify-content-md-center'>
                    {orderTypes && orderTypes.includes(ORDER_TYPE_DELIVERY) && (
                      <Button
                        type={PRIMARY}
                        className='mt-2 mr-0 mr-md-3'
                        onClick={() => {
                          onPressAddAddress(this, ORDER_TYPE_DELIVERY);
                        }}
                      >
                        {deliveryLabel}
                      </Button>
                    )}
                    {orderTypes && orderTypes.includes(ORDER_TYPE_CLICK_AND_COLLECT) && (
                      <Button
                        type={PRIMARY}
                        className='mt-2 ml-0 ml-md-3'
                        onClick={() => onPressAddAddress(this, ORDER_TYPE_CLICK_AND_COLLECT)}
                      >
                        {clickAndCollectLabel}
                      </Button>
                    )}
                  </div>
                  {!userConnected && !customerAddress && (
                    <div className='row justify-content-start align-items-center mt-2'>
                      <span className='align-baseline text-secondary'>
                        Vous avez déja une adresse?
                      </span>
                      <Button
                        type={LINK}
                        onClick={() => {
                          showConnexionModal(true);
                        }}
                        style={{ color: secondaryColor }}
                      >
                        Connectez-vous
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          )}
          {fromModal && (
            <div className='mt-3'>
              {loading && (
                <div className='row justify-content-center'>
                  <Spinner />
                </div>
              )}
              {!loading && (
                <div>
                  {orderTypes && orderTypes.includes(ORDER_TYPE_DELIVERY) && (
                    <Button
                      type={PRIMARY}
                      className='btn-block mt-2'
                      onClick={() => {
                        onPressAddAddress(this, ORDER_TYPE_DELIVERY);
                      }}
                    >
                      {deliveryLabel}
                    </Button>
                  )}
                  {orderTypes && orderTypes.includes(ORDER_TYPE_CLICK_AND_COLLECT) && (
                    <Button
                      type={PRIMARY}
                      className='btn-block mt-2'
                      onClick={() => onPressAddAddress(this, ORDER_TYPE_CLICK_AND_COLLECT)}
                    >
                      {clickAndCollectLabel}
                    </Button>
                  )}
                  {!userConnected && !customerAddress && (
                    <div className='row justify-content-center align-items-center mt-5'>
                      <span className='align-baseline'>Vous avez déja une adresse?</span>
                      <Button
                        type={LINK}
                        onClick={() => {
                          showConnexionModal(true);
                        }}
                        style={{ color: secondaryColor }}
                      >
                        Connectez-vous
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ userReducer, configurationReducer, shopReducer, componentReducer }) => {
  const { customerAddress, userConnected } = userReducer;
  const { secondaryColor, orderTypes, name, marketplace } = configurationReducer;
  const { addressShop } = shopReducer;
  const { isMobile, googleMapsEnabled, addressModal } = componentReducer;
  return {
    customerAddress,
    secondaryColor,
    orderTypes,
    addressShop,
    isMobile,
    googleMapsEnabled,
    userConnected,
    name,
    marketplace,
    addressModal
  };
};

export default connect(mapStateToProps, {
  showChooseShop,
  updateClosestShops,
  updateAddressTemp,
  showAddressModal,
  showConnexionModal
})(AddressInput);
